import { useEffect, useState } from "react";

export const VisionCarousel = ({ images }) => {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const timer = window.setTimeout(() => {
      setActive((current) => (current + 1) % images.length);
    }, 2000);

    return () => window.clearTimeout(timer);
  }, [active, images.length]);

  return (
    <div className="relative h-full w-full" data-testid="vision-carousel">
      {images.map((src, index) => (
        <img
          key={src}
          src={src}
          alt=""
          aria-hidden
          loading="eager"
          data-active={active === index}
          data-testid={`vision-carousel-image-${index + 1}`}
          className={`absolute inset-0 h-full w-full object-cover transition-[opacity,transform] duration-700 group-hover:scale-105 ${
            active === index ? "opacity-100" : "opacity-0"
          }`}
        />
      ))}

      <div
        className="absolute bottom-4 left-1/2 z-10 flex -translate-x-1/2 items-center gap-2 rounded-full border border-white/10 bg-black/45 px-3 py-2 backdrop-blur-md"
        data-testid="vision-carousel-thumbnails"
      >
        {images.map((src, index) => (
          <button
            key={src}
            type="button"
            aria-label={`Show carousel image ${index + 1}`}
            onClick={() => setActive(index)}
            data-active={active === index}
            data-testid={`vision-carousel-thumbnail-button-${index + 1}`}
            className={`h-10 w-7 overflow-hidden rounded-[4px] border transition-[border-color,opacity,transform] duration-300 hover:-translate-y-0.5 ${
              active === index ? "border-white opacity-100" : "border-white/20 opacity-55"
            }`}
          >
            <img
              src={src}
              alt=""
              aria-hidden
              className="h-full w-full object-cover"
              data-testid={`vision-carousel-thumbnail-image-${index + 1}`}
            />
          </button>
        ))}
      </div>
    </div>
  );
};